export default "__VITE_ASSET__C8wYLw3___"